import TableContainer from "../../../../../components/Tables/TableContainer";
import TableCell from "../../../../BillingAndPayments/components/TableCell";
import {
  VALUE_NUMBER,
  VALUE_WITH_CURRENCY_MANUAL_FORMAT,
  VALUE_WITH_PERCENTAGE,
} from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import TableRow from "@mui/material/TableRow";
import { useFormContext } from "react-hook-form";
import { renderMetricValue } from "../../../../../utils/renderMetricValue";

const GoogleKeywordRow = ({ indexCampaign, keyword, data, columns }) => {
  const { t } = useTranslationApp();
  const { getCostByMainCurrency } = useFormContext();

  const { cost, currency } = getCostByMainCurrency({
    cost: data.spend,
    currency: data.currency,
  });

  const { cost: costPerMainAction, currency: currencyPerMainAction } =
    getCostByMainCurrency({
      cost: data.costPerMainAction,
      currency: data.currency,
    });

  return (
    <TableContainer
      hasPagination={false}
      rounded={false}
      hasMarginBottom={false}
      keys={[""]}
    >
      <TableRow>
        <TableCell indexRow={indexCampaign} sx={{ width: 25 }} level={3} />
        {columns.map((col) => (
          <TableCell
            key={col.key}
            indexRow={indexCampaign}
            level={3}
            sx={{ width: 192, maxWidth: 192, minWidth: 192, height: 0 }}
          >
            {(() => {
              switch (col.key) {
                case "platform":
                  return keyword;
                case "spend":
                  return t(VALUE_WITH_CURRENCY_MANUAL_FORMAT, {
                    value: cost,
                    currency,
                  });
                case "impressions":
                  return t(VALUE_NUMBER, { value: data.impressions || 0 });
                case "click":
                  return t(VALUE_NUMBER, { value: data.click || 0 });
                case "ctr":
                  return t(VALUE_WITH_PERCENTAGE, { value: data.ctr || 0 });
                case "mainAction":
                  return t(VALUE_NUMBER, { value: data.mainAction || 0 });
                case "costPerMainAction":
                  return renderMetricValue(
                    costPerMainAction,
                    col.key,
                    currencyPerMainAction
                  );
                case "cpc":
                  return t(VALUE_WITH_CURRENCY_MANUAL_FORMAT, {
                    value: (data.cpc || 0).toFixed(2),
                    currency: data.currency,
                  });
                case "cpm":
                  return t(VALUE_WITH_CURRENCY_MANUAL_FORMAT, {
                    value: (data.cpm || 0).toFixed(2),
                    currency: data.currency,
                  });
                default:
                  return renderMetricValue(
                    data[col.key],
                    col.key,
                    data.currency
                  );
              }
            })()}
          </TableCell>
        ))}
      </TableRow>
    </TableContainer>
  );
};

export default GoogleKeywordRow;
